if (!customElements.get('product-specs')) {
  class ProductSpecs extends HTMLElement {
    constructor() {
      super();
      
      this.specsEl = this.querySelector('.js-product-specs');
      this.variantSpecsJsonEl = this.specsEl.querySelector('[type="application/json"][data-variants]');
      this.productSpecsJsonEl = this.specsEl.querySelector('[type="application/json"][data-product]');
      this.specsData = this.getSpecsData();
      this.specsTableEl = this.specsEl.querySelector('.js-specs-table');
      this.nutritionFactsEl = this.querySelector(".js-nutrition-facts");
    
      if (this.nutritionFactsEl) {
        this.nutritionFactsEl.querySelector('button').addEventListener("click", this.toggleNutritionFacts.bind(this));
      }

      document.addEventListener('on:variant:load', this.handleVariantChange.bind(this));
      document.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
    }

    getSpecsData() {
      return {
        product: this.productSpecsJsonEl ? JSON.parse(this.productSpecsJsonEl.textContent) : {},
        variants: this.variantSpecsJsonEl ? JSON.parse(this.variantSpecsJsonEl.textContent) : []
      }
    }

    handleVariantChange(e) {
      const variantId = e.detail?.variant?.id;
      const variant = variantId ? this.specsData.variants[variantId] : {};
      const product = this.specsData.product || {}

      if (!product.title) return;

      const data = {
        title: `${product.title}${variant ? ` - ${variant.title}` : ''}`,
        madeIn: variant?.madeIn || product.madeIn || null,
        usedFor: variant?.usedFor || product.usedFor || null,
        serves: variant?.serves || product.serves || null,
        valueForMoney: variant?.valueForMoney || product.valueForMoney || null,
        athleteTested: product.athleteTested || null,
        dietaryNeeds: variant?.dietaryNeeds || product.dietaryNeeds || null,
        productForm: variant?.productForm || product.productForm || null,
      }

      this.specsTableEl.innerHTML = this.getSpecsTableInnerHTML(data);
    }

    getSpecsTableInnerHTML(data) {
      return `
        <dt class="gg-product-specs__label"><span>Product</span></dt>
        <dd class="gg-product-specs__data">${data.title}</dd>
        ${data.madeIn ? `
          <dt class="gg-product-specs__label"><span>Made In</span></dt>
          <dd class="gg-product-specs__data">${data.madeIn}</dd>
        ` : ""}
        ${data.usedFor ? `
          <dt class="gg-product-specs__label"><span>Used For</span></dt>
          <dd class="gg-product-specs__data">${data.usedFor}</dd>
        ` : ""}
        ${data.serves ? `
          <dt class="gg-product-specs__label"><span>Serves</span></dt>
          <dd class="gg-product-specs__data">${data.serves}</dd>
        ` : ""}
        ${data.valueForMoney ? `
          <dt class="gg-product-specs__label"><span>Value for Money</span></dt>
          <dd class="gg-product-specs__data">${data.valueForMoney} per serve</dd>
        ` : ""}
        ${data.athleteTested ? `
          <dt class="gg-product-specs__label"><span>Athlete Tested</span></dt>
          <dd class="gg-product-specs__data">${data.athleteTested}</dd>
        ` : ""}
        ${data.dietaryNeeds ? `
          <dt class="gg-product-specs__label"><span>Dietary Needs</span></dt>
          <dd class="gg-product-specs__data">${data.dietaryNeeds}</dd>
        ` : ""}
        ${data.productForm ? `
          <dt class="gg-product-specs__label"><span>Product Form</span></dt>
          <dd class="gg-product-specs__data">${data.productForm}</dd>
        ` : ""}
      `
    }

    toggleNutritionFacts() {
      const isOpen = this.nutritionFactsEl.dataset.open === "true";
      this.nutritionFactsEl.dataset.open = !isOpen;
    }
  }


  customElements.define('product-specs', ProductSpecs);
}
